import PropTypes from 'prop-types';

export const ResidenceViewPropTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape( {
      type: PropTypes.string,
      data: PropTypes.oneOfType( [
        PropTypes.shape( {
          service: PropTypes.string,
          serviceVideoId: PropTypes.string,
        } ),
        PropTypes.arrayOf(
          PropTypes.shape( {
            uuid: PropTypes.string,
            image: PropTypes.shape( {
              modal: PropTypes.string,
            } ),
            caption: PropTypes.string,
          } ),
        ),
      ] ),
    } ),
  ),
};

export const ResidenceViewDefaultProps = {
  data: [],
};
